"use strict";

exports.__esModule = true;

var _Switch = require("react-router/Switch");

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/Switch.js
// module id = 652
// module chunks = 168707334958949